import React from "react";
import { useNavigate } from "react-router-dom";

const Footer: React.FC = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  const openMIIT = () => {
    window.open("https://beian.miit.gov.cn/", "_blank");
  };

  return (
    <footer className="bg-brand-dark text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {/* Logo & Info */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img
                src="/assets/images/header.png"
                alt="Logo"
                className="h-8 w-auto brightness-0 invert"
              />
              <span className="text-lg font-semibold">嘉屹工作室</span>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed">
              专注于打造精致的效率工具，
              <br />
              让科技真正服务于生活。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold mb-4 text-gray-300">
              快速链接
            </h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => {
                    const element = document.getElementById("products");
                    if (element) element.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="text-sm text-gray-400 hover:text-white transition-colors"
                >
                  产品
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate("/privacy")}
                  className="text-sm text-gray-400 hover:text-white transition-colors"
                >
                  隐私政策
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm font-semibold mb-4 text-gray-300">
              联系我们
            </h3>
            <p className="text-sm text-gray-400">
              <a
                href="mailto:gejw@gejw.cn"
                className="hover:text-white transition-colors"
              >
                gejw@gejw.cn
              </a>
            </p>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-800 mt-10 pt-8">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4">
            <span className="text-xs text-gray-500">
              &copy; {currentYear} 嘉屹软件开发工作室
            </span>
            <span className="hidden sm:inline text-gray-600">|</span>
            <button
              onClick={openMIIT}
              className="text-xs text-gray-500 hover:text-gray-400 transition-colors"
            >
              苏ICP备2022020421号-1
            </button>
            <span className="hidden sm:inline text-gray-600">|</span>
            <button
              onClick={() => navigate("/privacy")}
              className="text-xs text-gray-500 hover:text-gray-400 transition-colors"
            >
              隐私政策
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
